import PropTypes from 'prop-types';

import Icon from '../Icon';

import * as S from './style';
import * as T from '../Typography';

const TextWithIcon = ({
  color = 'neutralMain',
  bgColor,
  size,
  to,
  iconProps: _iconProps,
  text,
  textSize = 'small',
  external,
  underline,
  isButton,
  handleClick,
  weight,
  disabled,
  m,
  mr,
  isText,
  ...props
}) => {
  const { _color = 'secondaryMain', icon = 'phone' } = _iconProps || {
    color: 'secondaryMain',
    pointer: true,
    icon: 'phone',
  };
  const iconProps = {
    color: _color,
    icon,
    pointer: true,
    ..._iconProps,
  };

  if (isButton)
    return (
      <S.Button
        {...m}
        {...props}
        onClick={handleClick}
        disabled={disabled}
        type="button"
      >
        {icon && <Icon {...iconProps} mr={text ? mr || '2' : '0'} />}
        {text && (
          <T.P
            weight={weight}
            color={color}
            ml={icon === null && 6}
            td={underline && 'underline'}
          >
            {text}
          </T.P>
        )}
      </S.Button>
    );

  if (isText)
    return (
      <S.Wrapper bgColor={bgColor} size={size} {...props}>
        {icon && <Icon {...iconProps} mr={mr || '11.5px'} />}
        <T.P
          to={to}
          color={color}
          weight={weight}
          td={underline && 'underline'}
          {...props}
        >
          {text}
        </T.P>
      </S.Wrapper>
    );

  return (
    <S.Wrapper bgColor={bgColor} size={size} {...props} {...m}>
      {icon && <Icon {...iconProps} mr={mr || '11.5px'} />}
      <T.Link
        to={to}
        color={color}
        external={external}
        underline={underline}
        {...props}
      >
        <T.P weight={weight} color={color} size={textSize}>
          {text}
        </T.P>
      </T.Link>
    </S.Wrapper>
  );
};

TextWithIcon.propTypes = {
  href: PropTypes.string.isRequired,
};

export default TextWithIcon;
